import { render, staticRenderFns } from "./DeleteAccountAdditionalDetailsBtn.vue?vue&type=template&id=24163c91&"
import script from "./DeleteAccountAdditionalDetailsBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountAdditionalDetailsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports